module.exports = fox => {
	'use strict';

	fox.registerWidget('MCP_Login_Wizard_ForgotForm', {
		configure() {
			this.registerOptions('', {
                template: 'forgot_form'
			});

			return this.callParent('configure', arguments);
        },
        
        getTextMessage(alias) {
            let msg = '';

            switch (alias) {
                case 'emailNotValid':
                    msg = 'Email is not valid';
                case 'fieldNotEmpty':
                    msg = 'Fields shouldn\'t be empty';
                break;
            }

            return msg;
        },

        showErrorMessage(msg, fieldName) {
            //console.log(msg, fieldName)
            var $elm = $(this.dom1(`[name="${fieldName}"]`)).parent().find('.error-container');

            $elm.text(msg);
        },

        answerSendRecoveryMail(response) {
            this.togglePreloader(false);
            
            if (!response.success) {
				this.notices.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'error',
					noticeMessage: response.text,
					noticeAlias: 'loginError',
					delayClose: 3000
				});
				var button = fox.dom.selectFirst('.button-with-spinner', this.element);
				fox.dom.removeClass('spin', button);
			} else {
				$('.fill').text(response.text);
				$('.action-btns').html('<a href="/" class="btn btn-primary">OK</a>').css({'justify-content': 'center'});
			}
        }

	}, 'Login_Wizard_ForgotForm');
};



// WEBPACK FOOTER //
// ./components/login-wizard/widget/forgot-form.es.js